var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 24,
    viewBox: "0 0 49 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 23,
    rx: 3.5,
    stroke: "#DBDADE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.142 9.83626C25.1206 11.5079 26.6418 12.4407 27.7878 12.9954C28.9651 13.5644 29.3606 13.9293 29.3559 14.4382C29.3471 15.217 28.4168 15.5607 27.5462 15.5741C26.0273 15.5975 25.1442 15.1668 24.4421 14.8411L23.8949 17.3841C24.5993 17.7065 25.9037 17.9877 27.2562 18C30.4312 18 32.5083 16.4433 32.5196 14.0298C32.532 10.9666 28.254 10.7971 28.2832 9.42793C28.2933 9.01277 28.6921 8.56975 29.566 8.45711C29.9986 8.4002 31.1928 8.35666 32.5466 8.9759L33.078 6.51546C32.3499 6.25214 31.4142 6 30.2491 6C27.2608 6 25.1589 7.57788 25.142 9.83626ZM38.184 6.21193C37.6042 6.21193 37.1157 6.54783 36.8976 7.06329L32.3623 17.8193H35.535L36.1663 16.0862H40.0432L40.4095 17.8193H43.2058L40.7656 6.21193H38.184ZM38.6278 9.34751L39.5434 13.7062H37.0359L38.6278 9.34751ZM21.2953 6.21208L18.7945 17.8191H21.8178L24.3174 6.21179L21.2953 6.21208ZM16.8229 6.21208L13.6761 14.1124L12.4032 7.39483C12.2538 6.64494 11.664 6.21193 11.009 6.21193H5.86502L5.79297 6.54899C6.849 6.7766 8.04884 7.14371 8.77576 7.53651C9.22062 7.77645 9.34748 7.98621 9.49362 8.55639L11.9046 17.8193H15.0994L19.9976 6.21193L16.8229 6.21208Z",
    fill: "url(#paint0_linear_5726_7241)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5726_7241",
    x1: 1725.81,
    y1: 42.072,
    x2: 1760.31,
    y2: -1190.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaWalletIcon);
export default __webpack_public_path__ + "static/media/VisaWalletIcon.bde5e0aa021f02599337117476dcf86f.svg";
export { ForwardRef as ReactComponent };